/* eslint-disable no-throw-literal */
import client from '../../Components/Client';
import service from './service';

class Session {
  constructor(token, expiresIn, webVersionNumber, webUpdateSeen) {
    this.token = token;
    this.expiry = new Date().getTime() + expiresIn * 1000;
    this.webVersionNumber = webVersionNumber;
    this.webUpdateSeen = webUpdateSeen;
  }
}

export const login = async (username, password) => {
  try {
    const response = await client.post('/auth/login', {
      email: username,
      password: password,
      platform: 'W',
    });

    if (response.status === 200) {
      const data = response.data;

      if (data.type === 'AUTHENTICATION_RESULT') {
        const session = new Session(
          data.accessToken,
          data.expiresIn,
          data.webVersionNumber,
          data.webUpdateSeen
        );
        service.setSession(session);
        return session;
      } else {
        // MFA ----
        throw 'Not Implemented yet';
      }
    }
  } catch (error) {
    throw error?.response?.data;
  }
};

export const getUserLevelAccessControl = async (token) => {
  const response = await client.get(`/users/self/access-controls`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getResetPasswordConfirmationCode = async (username) => {
  const response = await client.post('/auth/forgot-password', {
    username: username,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const RestPassword = async (username, password, code) => {
  const response = await client.post('/auth/reset-password', {
    username,
    password,
    confirmationCode: code,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const ChangePassword = async (oldPassword, newPassword) => {
  const response = await service.post('/auth/change-password', {
    oldPassword,
    newPassword,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const accountTransfer = async (payload) => {
  const response = await service.post('/auth/transfer-account', payload);
  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const resendVerificationCode = async (email) => {
  const response = await client.post('/auth/resendOTP', {
    email: email.trim(),
  });

  if (response.status === 200) {
    const data = response.data;
    return data;
  }

  throw 'verification failed';
};

export const verification = async (email, verification_code) => {
  const response = await client.post('/auth/verify', {
    username: email.trim(),
    verificationCode: verification_code.trim(),
  });

  if (response.status === 200) {
    const data = response.data;
    return data;
  }

  throw 'verification failed';
};
